import type { CmpHider } from './types';

export const termly: CmpHider = {
  id: 'termly',
  label: 'Termly',
  css: `
      /* Termly (termly.io CMP): the whole consent UI is injected into a single
         root container "#termly-code-snippet-support" that lives directly on
         <body> and holds both the fixed consent banner (a fixed, z-index
         999999 div whose buttons carry data-tid="banner-accept"/"banner-decline")
         and the preferences modal. Hiding that root removes the banner and the
         modal in one go. The banner element itself uses build-hashed classes
         ("termly-styles-root-..." / "termly-styles-main-...") that change per
         deploy, so we also match the stable "termly-styles-" class prefix and
         the data-tid action hooks defensively, plus the legacy/named preferences
         modal and overlay/backdrop selectors (.t-preference-modal,
         .t-preference-modal-overlay, .t-overlay, .t-consent-banner) in case a
         build renders them outside the root. Termly does not lock page scroll
         via a body class or inline style on the sites observed; if a build does,
         the html/html-body[style*="overflow"] release rule above (added for
         Cookiebot) already out-specifies an inline overflow lock. */
      #termly-code-snippet-support,
      .t-consent-banner,
      .t-preference-modal,
      .t-preference-modal-overlay,
      .t-overlay,
      [class*="termly-styles-root-"],
      [data-tid="banner-accept"],
      [data-tid="banner-decline"] { display: none !important; }
  `,
};
